import React from 'react';
import styles from './LoadingScreen.module.css';

interface LoadingScreenProps {
  progress?: number;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ progress }) => {
  return (
    <div className={styles.loadingScreen}>
      <div className={styles.content}>
        <div className={styles.spinner}></div>
        <h2 className={styles.title}>Loading...</h2>
        {progress !== undefined && (
          <div className={styles.progressBar}>
            <div 
              className={styles.progressFill} 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;